/*
import {
  gs,
  hf,
  ht,
  cr,
  ls,
} from 'lib';
*/
import * as cr from './_cr';
import * as ls from "./_csLcl"; // local state

import * as icm from './icm';

import * as Iccv30 from './icvBaseK10Rz';

import * as icvI19K10To from './icvI19K10To';
import * as icvI19K10Co from './icvI19K10Co';

export const N = (pDz: {
}) => {

  const _sPz = ls.usePagez({
    steps: [0],
    phs: 'dpy',
    lblz: icm.grtLblz({
      tgt: 'クライアント',
    })
  });

  icm.loadAtTopAsync({
    _31r_fst: 0,
    frcUdt: _sPz.udt,
  });

  return (
    cr.c(Iccv30.N, {
      key: -10,
      cz: {
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            _sPz.crt.lblz.ttlz.top
          : _sPz.crt.steps[0] == 1 ?
            _sPz.crt.lblz.ttlz.ctt
          : ''
      },
      oClds: [

        _sPz.crt.steps[0] == 0?
        cr.c(icvI19K10To.N, {
          key: -10,
          sPz: _sPz,
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icvI19K10Co.N, {
          key: -20,
          sPz: _sPz,
        })
        : null,

      ]
    })
  );
};
